/**
 * Header-Verhalten: mobile Navigation und Scroll-Zustand.
 * Ausgangszustand ist ohne JS bedienbar — die Nav ist nur zugeklappt, nicht weg.
 */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('nav-mobile');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var willOpen = nav.hasAttribute('hidden');

      if (willOpen) {
        nav.removeAttribute('hidden');
      } else {
        nav.setAttribute('hidden', '');
      }

      toggle.setAttribute('aria-expanded', String(willOpen));
    });

    /* Escape schliesst und gibt den Fokus zurueck an den Burger. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || nav.hasAttribute('hidden')) return;

      nav.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    });
  }

  var header = document.querySelector('[data-site-header]');

  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/**
 * Kopfleiste, die beim Hochscrollen zurueckkommt.
 *
 * Warum ueberhaupt: `.site-header` trug zwar `position: sticky`, blieb aber
 * nie stehen. Ein Sticky-Element wandert nur innerhalb seines Elternteils —
 * und der Section-Wrapper ist exakt so hoch wie der Header selbst. Null
 * Spielraum, also null Haftung. Deshalb haftet jetzt die ganze Kopfgruppe.
 *
 * Verhalten (nur bis 899 px): Runterscrollen blendet Ankuendigung und Header
 * aus, Hochscrollen holt sie zurueck. Auf dem Handy ist der erste Bildschirm
 * knapp — eine dauerhaft sichtbare Leiste kostet dort mehr, als sie nuetzt.
 *
 * Ganz oben ist die Leiste immer da, damit die Seite nicht kopflos beginnt.
 */
(function () {
  'use strict';

  var gruppe = document.querySelector('.shopify-section-group-header-group');
  if (!gruppe) return;

  var mobil = window.matchMedia('(max-width: 899px)');
  var nav = document.getElementById('nav-mobile');
  var letzte = window.scrollY;
  var schwelle = 240; /* erst ab hier ausblenden — sonst zuckt es beim Start */
  var wartet = false;

  function pruefen() {
    wartet = false;
    var jetzt = window.scrollY;

    /* Nicht ausblenden, solange das Menue offen ist — sonst verschwindet es
       unter dem Finger. */
    var menueOffen = nav && !nav.hasAttribute('hidden');

    if (!mobil.matches || menueOffen || jetzt <= schwelle) {
      document.documentElement.classList.remove('kopf-weg');
    } else if (jetzt > letzte + 6) {
      document.documentElement.classList.add('kopf-weg');
    } else if (jetzt < letzte - 6) {
      document.documentElement.classList.remove('kopf-weg');
    }

    letzte = jetzt;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(pruefen);
    },
    { passive: true }
  );

  mobil.addEventListener('change', pruefen);
})();
